import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentExpertBlockReset, EPostContentExpertBlockActionType } from './types';

export const postContentExpertBlockReset: () => TPostContentExpertBlockReset =
  actionGenerator<EPostContentExpertBlockActionType.Reset>(EPostContentExpertBlockActionType.Reset);
